<template>
  <el-dialog title="终稿审核" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true" width="780px">
    <div class="article_box">

      <div class="article_picture">
          <h3>封面：</h3>
        <el-image style="width: 150px; height: 120px" :src="draftData.evaluation.cover_img_vertical"
          fit="cover"></el-image>
      </div>

      <div class="article_title">
        <h3>活动名称：</h3>
        <p class="article_name">{{ draftData.evaluation.name }}</p>
      </div>

    </div>
    <div class="draft-content" v-if="draftData.final_draft_content">
      <!-- <div class="content-item" v-for="(item, index) in draftData.final_draft_content" :key="index"> -->
      <div class="content-item border_t" v-if="draftData.final_draft_content['1']">
        <div class="name-box">
           <h3 style="margin-top:0">测评平台：</h3>
          <el-tag class="name">小红书</el-tag>
        </div>
        <div class="btn-box">
          <h3 style="margin-top:0">平台链接：</h3>
          <el-button type="primary" icon="el-icon-link" size="small"
            @click="openLink(draftData.final_draft_content['1'])">访问链接</el-button>
          <el-button type="success" icon="el-icon-tickets" size="small"
            @click="copyLink(draftData.final_draft_content['1'])">复制链接</el-button>
        </div>
      </div>
      <div class="content-item border_t" v-if="draftData.final_draft_content['2']">
        <div class="name-box">
           <h3 style="margin-top:0">测评平台：</h3>
          <el-tag class="name">抖音</el-tag>
        </div>
        <div class="btn-box">
          <h3 style="margin-top:0">平台链接：</h3>
          <el-button type="primary" icon="el-icon-link" size="small"
            @click="openLink(draftData.final_draft_content['2'])">访问链接</el-button>
          <el-button type="success" icon="el-icon-tickets" size="small"
            @click="copyLink(draftData.final_draft_content['2'])">复制链接</el-button>
        </div>
      </div>
      <div class="content-item border_t" v-if="draftData.final_draft_content['3']">
        <div class="name-box">
           <h3 style="margin-top:0">测评平台：</h3>
          <el-tag class="name">微博</el-tag>
        </div>
        <div class="btn-box">
          <h3 style="margin-top:0">平台链接：</h3>
          <el-button type="primary" icon="el-icon-link" size="small"
            @click="openLink(draftData.final_draft_content['3'])">访问链接</el-button>
          <el-button type="success" icon="el-icon-tickets" size="small"
            @click="copyLink(draftData.final_draft_content['3'])">复制链接</el-button>
        </div>
      </div>
      <div class="content-item border_t" v-if="draftData.final_draft_content['4']">
        <div class="name-box">
           <h3 style="margin-top:0">测评平台：</h3>
          <el-tag class="name">微信朋友圈</el-tag>
        </div>
        <div class="btn-box">
          <h3 style="margin-top:0">平台链接：</h3>
          <el-button type="primary" icon="el-icon-link" size="small"
            @click="openLink(draftData.final_draft_content['4'])">访问链接</el-button>
          <el-button type="success" icon="el-icon-tickets" size="small"
            @click="copyLink(draftData.final_draft_content['4'])">复制链接</el-button>
        </div>
      </div>
      <div class="content-item border_t" v-if="draftData.final_draft_content['5']">
        <div class="name-box">
           <h3 style="margin-top:0">测评平台：</h3>
          <el-tag class="name">大众点评</el-tag>
        </div>
        <div class="btn-box">
          <h3 style="margin-top:0">平台链接：</h3>
          <el-button type="primary" icon="el-icon-link" size="small"
            @click="openLink(draftData.final_draft_content['5'])">访问链接</el-button>
          <el-button type="success" icon="el-icon-tickets" size="small"
            @click="copyLink(draftData.final_draft_content['5'])">复制链接</el-button>
        </div>
      </div>
      <div class="content-item border_t" v-if="draftData.final_draft_content['6']">
        <div class="name-box">
           <h3 style="margin-top:0">测评平台：</h3>
          <el-tag class="name">马蜂窝</el-tag>
        </div>
        <div class="btn-box">
          <h3 style="margin-top:0">平台链接：</h3>
          <el-button type="primary" icon="el-icon-link" size="small"
            @click="openLink(draftData.final_draft_content['6'])">访问链接</el-button>
          <el-button type="success" icon="el-icon-tickets" size="small"
            @click="copyLink(draftData.final_draft_content['6'])">复制链接</el-button>
        </div>
      </div>
      <div class="content-item border_t" v-if="draftData.final_draft_content['7']">
        <div class="name-box">
           <h3 style="margin-top:0">测评平台：</h3>
          <el-tag class="name">微信公众号</el-tag>
        </div>
        <div class="btn-box">
          <h3 style="margin-top:0">平台链接：</h3>
          <el-button type="primary" icon="el-icon-link" size="small"
            @click="openLink(draftData.final_draft_content['7'])">访问链接</el-button>
          <el-button type="success" icon="el-icon-tickets" size="small"
            @click="copyLink(draftData.final_draft_content['7'])">复制链接</el-button>
        </div>
      </div>
      <div class="content-item border_t" v-if="draftData.final_draft_content['8']">
        <div class="name-box">
           <h3 style="margin-top:0">测评平台：</h3>
          <el-tag class="name">微信视频号</el-tag>
        </div>
        <div class="btn-box">
          <h3 style="margin-top:0">平台链接：</h3>
          <el-button type="primary" icon="el-icon-link" size="small"
            @click="openLink(draftData.final_draft_content['8'])">访问链接</el-button>
          <el-button type="success" icon="el-icon-tickets" size="small"
            @click="copyLink(draftData.final_draft_content['8'])">复制链接</el-button>
        </div>
      </div>
    </div>
    <div class="draft-media">
      <h3>测评图片/视频</h3>
      <div class="media-box">
        <div class="video-box" v-for="mediaItem in videoList" :key="mediaItem" @click="onPlayVideo(mediaItem)">
          <video style="display: block; width: 150px; height: 150px;" :src="mediaItem" muted></video>
          <i class="play-icon el-icon-video-play"></i>
        </div>
        <el-image style="width: 150px; height: 150px; margin: 5px; border: 1px dashed #d1e9ff;"
          v-for="mediaItem in pictureList" :key="mediaItem" :src="mediaItem" fit="cover"
          :preview-src-list="pictureList"></el-image>
      </div>
    </div>
    <div class="reject" v-if="(draftData.state === 7 || draftData.state === 8) &&
      draftData.final_draft_reject
      ">
      <h3>驳回原因</h3>
      <div class="reject-content" v-html="draftData.final_draft_reject"></div>
    </div>
    <div class="option-box">
      <el-button @click="trunOff">返回</el-button>
      <template v-if="draftData.state === 7">
        <el-button type="warning" @click="rejectModal = true">驳回</el-button>
        <el-button type="primary" :loading="submitting" @click="onFirstDraftPass">通过</el-button>
      </template>
    </div>

    <el-dialog title="驳回" :visible.sync="rejectModal" :close-on-click-modal="false" :destroy-on-close="true"
      append-to-body width="780px">
      <el-form ref="rejectForm" :model="form" :rules="rejectRules">
        <el-form-item prop="reject">
          <!-- <el-input type="textarea" :rows="4" v-model="form.reject" placeholder="驳回理由" /> -->
          <tinymce style="width:100;" :height="500" v-model="form.reject" ref="tinymce" />
        </el-form-item>
        <div>
          <el-button @click="rejectModal = false">取消</el-button>
          <el-button type="primary" :loading="submitting" @click="onReject('rejectForm')">确认</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="视频播放" v-if="videoVisible" :visible.sync="videoVisible" :close-on-click-modal="false"
      :destroy-on-close="true" width="60%" append-to-body>
      <video width="100%" height="550px" :src="videoUrl" autoplay controls></video>
    </el-dialog>
  </el-dialog>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import { zhongcao } from "@/api/order";

export default {
  data: () => ({
    rejectModal: false,
    rejectRules: {
      reject: [{ required: true, message: "请输入驳回理由", trigger: "blur" }],
    },
    pictureList: [],
    videoList: [],
    videoVisible: false,
    videoUrl: null,
    form: {
      order_id: null,
      type: null,
      reject: null,
    },
    submitting: false,
  }),
  components: { Tinymce },
  props: {
    // 展示
    show: {
      default: false,
      type: Boolean,
    },
    draftData: Object,
  },
  methods: {
    trunOff() {
      this.showModal = false;
    },
    onReject(formName) {
      this.form.type = 2;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.submitting = true;
            await zhongcao.finalDraftReview(this.form);
            this.$message({
              message: "已驳回!",
              type: "success",
            });
            this.$emit("onUpdate");
            this.trunOff();
          } catch {
            this.$message.error("出错了!");
          } finally {
            this.submitting = false;
          }
        }
      });
    },
    onPlayVideo(url) {
      this.videoUrl = url;
      this.videoVisible = true;
    },
    onFirstDraftPass() {
      this.$confirm("此操作将通过审核, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(async () => {
          this.form.type = 1;
          try {
            await zhongcao.finalDraftReview(this.form);
            this.$message({
              type: "success",
              message: "已通过审核!",
            });
            this.$emit("onUpdate");
            this.trunOff();
          } catch {
            this.$message.error("取消审核通过!");
          }
        })
        .catch(() => {
          this.$message("审核取消!");
        });
    },
    openLink(url) {
      if (url.search(/^((https|http)?:\/\/)[^\s]+/) === -1){
        // return this.$message({
        //   message: "这貌似不是一个正确的链接, 请复制查看!",
        //   type: "warning",
        // });
        url = 'https://' + url
      }
        
      window.open(url, "_blank");
    },
    async copyLink(link) {
      try {
        await this.$copyText(link);
        this.$message({
          message: "复制剪贴板成功",
          type: "success",
        });
      } catch (err) {
        console.log(err);
        this.$message({
          message: "复制失败",
          type: "warning",
        });
      }
    },
  },
  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  // watch: {
  //     show(val) {
  //         if (val) {
  //             this.form.order_id = this.draftData.order_id
  //         }
  //     }
  // },
  created() {
    this.form.order_id = this.draftData.order_id;
    if(this.draftData.final_draft_url.length > 0){

      this.draftData.final_draft_url.map((item) => {
        if (item.type === 1) {
          this.pictureList.push(item.path);
        } else if (item.type === 2) {
          this.videoList.push(item.path);
        }
      });

    }
  },
};
</script>

<style lang="scss">
.media-box {
  margin: -5px;

  .video-box {
    position: relative;
    display: inline-block;
    width: 150px;
    height: 150px;
    margin: 5px;
    border: 1px dashed #d1e9ff;
    cursor: pointer;

    .play-icon {
      font-size: 3rem;
      color: white;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.article_box {
  padding-bottom: 15px;
  // display: flex;
  // align-items: flex-start;
  .article_picture {
    display: flex;
    align-items: flex-start;

    h3 {
      margin-top: 0 !important;
    }
  }

  .article_title {
    display: flex;
    align-items: center;

    .article_name {
      font-size: 1rem;
      margin: 0;
      margin-left: 10px;
    }
  }

}

.border_t{
  // padding-top: 15px;
  // border-top: 1px solid #ccc;
  
  border-top: 1px solid #ccc;
}

.draft-content {
  .content-item {
    // display: flex;
    // align-items: center;
    padding: 10px 0;
    width: 50%;

    // font-size: 1rem;

    .name-box {
      display: flex;
      height: 50px;
      text-align: right;

      .item-name {
        // font-size: 1rem;
      }
    }

    .btn-box {
      display: flex;
      height: 30px;
      // margin-left: 20px;
    }
  }
}

.reject-content {
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
  }
}

.option-box {
  margin-top: 18px;
}
</style>
